import Api from "./Api";

class XlsApi extends Api {
  getStatusUrl() {
    const url = `${this.url}/disclosurecode/private/report/xls/status`;
    return url;
  }

  getReportUrl(id?: string | number) {
    const url = `${this.url}/disclosurecode/private/report/xls/report/${id}`;
    return url;
  }

  getPreliminaryReportUrl(id?: string | number) {
    const url = `${this.url}/disclosurecode/private/preliminaryreport/xls/report/${id}`;
    return url;
  }

  getYearlyUrl() {
    const url = `${this.url}/disclosurecode/private/report/xls/yearly/`;
    return url;
  }

  getBeneficiaryUrl() {
    const url = `${this.url}/disclosurecode/private/report/xls/beneficiary/`;
    return url;
  }

  getHcpIndUrl() {
    const url = `${this.url}/disclosurecode/private/report/xls/hcpind/`;
    return url;
  }

  getAllReportsZipUrl() {
    const url = `${this.url}/disclosurecode/private/report/xls/allreports/`;
    return url;
  }

  getAllReportsUrl() {
    const url = `${this.url}/disclosurecode/private/report/xls/all/`;
    return url;
  }

  getAllPreliminaryReportsZipUrl() {
    const url = `${this.url}/disclosurecode/private/preliminaryreport/xls/allreports/`;
    return url;
  }

  getAllPreliminaryReportsUrl() {
    const url = `${this.url}/disclosurecode/private/preliminaryreport/xls/all/`;
    return url;
  }
}

export default new XlsApi();
